import { Outlet } from "react-router-dom";

export const ProjectSupervisionView = () => {
  return (
    <div className="general-view-container">
      <Outlet />
    </div>
  );
};
